import { Link } from "react-router-dom";

import Seo from "../../components/Seo";
import { seoFromPublicPage } from "../../seo/publicPages";
import ArticleLayout from "./ArticleLayout";

export default function DecontKilometriPage() {
  return (
    <>
      <Seo {...seoFromPublicPage("/decont-kilometri")} />
      <ArticleLayout
        eyebrow="Pe cursă"
        title="Decont de kilometri: când îl folosești în loc de combustibil pe firmă"
        lead="Mașina rămâne a persoanei fizice. Firma plătește kilometrii de serviciu. Bonurile de combustibil pe CUI, pentru aceleași curse, sunt a doua plată — și inspectorul o vede."
      >
        <p>
          Decontul e pentru deplasarea ocazională: client, furnizor, instituție. Firma{" "}
          <strong>nu preia</strong> mașina. Nu trece pe CUI carburantul, RCA-ul sau
          service-ul. Plătește o sumă lei/km, pe traseul de serviciu, către persoana care
          a condus.
        </p>

        <h2>Când e calea corectă</h2>
        <p>
          Alegi decontul când autoturismul stă pe numele administratorului sau al
          angajatului, iar cursele pentru firmă sunt din când în când. Mașina de zi cu
          zi a           activității are altă hârtie: <Link to="/foi-parcurs-comodat">comodat</Link>,
          apoi aceleași limite de 50% și 100% ca la un vehicul din patrimoniu. Cele
          două nu se amestecă pe aceleași curse. Bifurcația, pentru SRL, e în{" "}
          <Link to="/masina-personala-srl-comodat">articolul despre mașina personală</Link>.
        </p>
        <div className="article-doc__table-wrap">
          <table className="article-doc__table">
            <thead>
              <tr>
                <th>Situație</th>
                <th>Ce folosești</th>
                <th>Combustibil pe CUI?</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Câteva curse pe lună, mașina rămâne a persoanei</td>
                <td>Decont lei/km</td>
                <td>Nu</td>
              </tr>
              <tr>
                <td>Mașina e, de fapt, mașina de serviciu</td>
                <td>Comodat + foaie, dacă vrei 100%</td>
                <td>Da, cu 50% sau 100%</td>
              </tr>
              <tr>
                <td>Aceleași kilometri, de două ori</td>
                <td>Niciuna dintre variante nu ține</td>
                <td>Risc de recalculare</td>
              </tr>
            </tbody>
          </table>
        </div>
        <p>
          Decontul acoperă kilometrii. <strong>Diurna</strong> acoperă timpul petrecut în
          delegație. Sunt sume diferite, cu acte diferite. Un ordin de deplasare arată că
          firma a trimis omul. Nu înlocuiește traseul, kilometrii și plata.
        </p>

        <h2>Ce stă pe hârtie</h2>
        <p>
          Nu există formular ANAF pentru decontul de kilometri. Inspectorul vrea să vadă
          că suma a plecat pentru o cursă de activitate, înainte de a o deduce.
        </p>
        <ul>
          <li>regula internă: câți lei pe kilometru și din ce se calculează;</li>
          <li>traseul, scopul și data — clientul sau instituția, nu „deplasare”;</li>
          <li>kilometrii de serviciu;</li>
          <li>suma, și dovada plății către persoana fizică (ordin de plată).</li>
        </ul>
        <p>
          La impozit, cheltuiala ține dacă e făcută pentru activitate. Asta e regula din{" "}
          <strong>art. 25 alin. (1)</strong> din Codul fiscal. Fără traseu, scop și
          plată, suma arată a indemnizație rotundă, nu a deplasare.
        </p>

        <h2>Lei/km îl fixează firma</h2>
        <p>
          Nu există un tarif unic ANAF pentru firmele private. Baza simplă, scrisă în
          regulă: norma de consum a mașinii înmulțită cu prețul combustibilului din luna
          respectivă. Cifrele de mai jos sunt un exemplu de calcul, nu un plafon legal.
        </p>
        <p>
          7 litri la 100 km × 8 lei/litru = <strong>0,56 lei/km</strong>. O cursă de 100
          km până la client = <strong>56 lei</strong>, plătiți persoanei. Luna următoare,
          dacă prețul la pompă s-a schimbat, se schimbă și lei/km. Regula spune cum,
          ca să nu apară aceeași sumă în fiecare lună fără legătură cu drumul.
        </p>
        <p>
          Pe suma plătită unei persoane fizice <strong>nu ai TVA de dedus</strong>. Nu
          există factură cu taxă. Dacă vrei TVA pe combustibil, calea e comodatul (sau
          mașina deja pe firmă), cu limitele din{" "}
          <Link to="/deducere-100-combustibil">articolul despre deducerea 100%</Link>.
          Decontul închide alt subiect: transportul unei curse, nu dosarul mașinii.
        </p>

        <h2>Tabelul de rute arată cursele decontate</h2>
        <p>
          Lângă decont stă un tabel: dată, plecare, destinație, scop, kilometri. Poate
          fi o foaie scurtă, doar pentru cursele plătite. Nu e foaia lunară cu care
          justifici utilizarea exclusivă a unui autoturism de firmă. Acele patru
          elemente — categorie, scop și loc, kilometri, normă — sunt pentru dosarul de
          100%, explicate în <Link to="/ghid-foaie-parcurs-anaf">ghidul ANAF</Link>.
        </p>
        <p>
          La decont, norma intră în lei/km. Nu o mai treci și pe bonuri de carburant
          pentru aceeași distanță. Altfel ai plătit drumul de două ori: o dată către
          persoană, o dată către benzinărie, pe CUI.
        </p>

        <h2>Ce cade la control</h2>
        <p>
          Inspectorul nu respinge decontul din principiu. Respinge suma care nu se leagă
          de o cursă, sau care se suprapune peste cheltuieli deja trecute pe firmă.
        </p>
        <div className="article-doc__callout article-doc__callout--warning">
          <strong>De evitat</strong>
          <ul>
            <li>Decont și bonuri de combustibil pe aceiași kilometri.</li>
            <li>Lei/km rotund, fără regulă și fără legătură cu consumul și prețul.</li>
            <li>Aceeași sumă în fiecare lună, fără trasee.</li>
            <li>Plată fără ordin către persoana care a condus.</li>
            <li>Weekend, concediu sau drumul la mall, trecute ca vizită la client.</li>
          </ul>
        </div>

        <h2>Concluzie</h2>
        <p>
          Decontul e pentru cursa ocazională, cu mașina lăsată pe persoană fizică.
        </p>
        <p>
          <strong>Câteva drumuri pe lună.</strong> Regulă lei/km, traseu, scop,
          kilometri, ordin de plată. Combustibilul rămâne al persoanei. Tabelul de rute
          arată ce s-a decontat.
        </p>
        <p>
          <strong>Mașina e folosită curent pentru firmă.</strong> Acolo intră comodatul,
          iar cheltuielile pot trece pe CUI. Decontul pe aceleași curse dublează plata.
        </p>
        <p>
          Când hârtia spune o singură poveste — cine a mers, unde, câți kilometri și cui
          i s-a plătit — subiectul e închis. Poți trece la treabă.
        </p>
      </ArticleLayout>
    </>
  );
}
